import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import css from './index.module.scss';
import { EFArrowRightForAni } from '@/components/UI/svg/ProductStatic';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltamax/pc/');

export default function Comp({}: any) {
    const { useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const { t } = useLang('delta_max_static');
    const appRedirct = ['us', 'ca', 'uk', 'au', 'de', 'fr', 'jp'];

    return (
        <div className={`${css.gsapdGroupB} gsapdGroupB`}>
            <div className="a-msg-box">
                <div className="msg-line-a1">{t('EA')}</div>
                <div className="msg-line-a2">
                    {t.rich('EA_title', {
                        line1: (child: string) => <div className="msg-color1">{child}</div>,
                    })}
                </div>
                <div className="msg-line-desc">{t('EA_desc')}</div>
                <div className="msg-line-tips">{t('EA_notice')}</div>
                {appRedirct.includes(locale) && (
                    <Link href="/app" className="link_learn" newWin>
                        <div className="text2">{t('learn_more')}</div>
                        <div className="icon">
                            <EFArrowRightForAni />
                        </div>
                    </Link>
                )}
            </div>
            <div className="a-img-box">
                <EFPic name={[`img_0_${appImgLocal}.webp`, `img_0_${appImgLocal}.jpg`]} className="fullImgs" alt="" />
            </div>
        </div>
    );
}
